import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext, useSearchParams } from 'react-router-dom';
import usePagination from 'hooks/usePagination';
import { Loading } from 'components';
import boardService from 'services/board/board-service';
import { BOARD_ARCHIVE_MODULE_NO } from 'data/constants';

// Components
import ArchiveView from './ArchiveView';

export function Archive(props) {
  const navigate = useNavigate();
  const { langList } = useOutletContext();
  const [loading, setLoading] = useState(true);
  const [archiveList, setArchiveList] = useState([]);
  // 페이지네이션
  const [searchParams] = useSearchParams();
  const { paginationRequest, setPaginationRequest, paginationResult, setPaginationResult } = usePagination(navigate, searchParams);

  useEffect(() => {
    const fetchArchive = async function () {
      let data = [];

      try {
        const response = await boardService.listContents(BOARD_ARCHIVE_MODULE_NO, paginationRequest.pageNumber, paginationRequest.pageSize);

        if (response) {
          if (response.rows) {
            data = response.rows;
          }
          setPaginationResult(response);
        }
      } catch (e) {
        console.error(e);
      }

      setArchiveList(data);
    };

    if (paginationRequest) {
      fetchArchive();

      setLoading(false);
    }

    return () => setLoading(true);
  }, [paginationRequest]);

  return (
    <>
      {loading && <Loading />}
      <ArchiveView
        list={langList.archive}
        archiveList={archiveList}
        paginationRequest={paginationRequest}
        paginationResult={paginationResult}
        setPaginationRequest={setPaginationRequest}
      />
    </>
  );
}
